var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticStyle:{"enable-background":"new 0 0 24 24"},attrs:{"version":"1.1","id":"レイヤー_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":`${_vm.size}px`,"height":`${_vm.size}px`,"viewBox":"0 0 24 24","xml:space":"preserve"}},[_c('g',{attrs:{"id":"折れ線グラフ","transform":"translate(-201.802 -391)"}},[_c('path',{staticClass:"st0",style:({
        stroke: _vm.colors[0],
      }),attrs:{"id":"パス_343","d":"M202.4,393.6v18.8h23.4"}}),_c('path',{staticClass:"st1",style:({
        stroke: _vm.colors[1],
      }),attrs:{"id":"パス_344","d":"M207,406.8l5.1-7.2l5.5,3.3l5.9-7.6"}}),_c('circle',{style:({
        fill: _vm.colors[2],
      }),attrs:{"id":"楕円形_7","cx":"206.9","cy":"407","r":"1.9"}}),_c('circle',{style:({
        fill: _vm.colors[2],
      }),attrs:{"id":"楕円形_8","cx":"211.8","cy":"399.2","r":"1.9"}}),_c('circle',{style:({
        fill: _vm.colors[2],
      }),attrs:{"id":"楕円形_9","cx":"217.6","cy":"403.1","r":"1.9"}}),_c('circle',{style:({
        fill: _vm.colors[2],
      }),attrs:{"id":"楕円形_10","cx":"223.4","cy":"395.4","r":"1.9"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }